import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description: 'Indicates how risky a given subaward is',
    name: 'Subaward Risk Level',
    partialId: PartialId.Standard.create('subaward_risk'),
  },
  type: core.quiver.Resource.Type.DmsEnum,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnum>
